function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import _globalThis from "@babel/runtime-corejs3/core-js/global-this";
import _Symbol$for from "@babel/runtime-corejs3/core-js/symbol/for";
import _Array$isArray from "@babel/runtime-corejs3/core-js/array/is-array";
import _someInstanceProperty from "@babel/runtime-corejs3/core-js/instance/some";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import React from "react";
import { useClasses } from "@xo-union/react-css-modules";
import noop from "lodash/noop";
import styles from "./styles.css";
var toClassList = function toClassList(classesString) {
  return classesString.split(/\s+/);
};

// When globalThis is used with array access Babel does not insert the polyfill.
// This alias is defined as a workaround.
var globalAlias = _globalThis;
var $noScrollMountCount = _Symbol$for('@xo-union/ui-accessibility/no-scroll-mounts');
globalAlias[$noScrollMountCount] = globalAlias[$noScrollMountCount] || 0;

// Render refs are useful to keep a reference to the latest rendered value
// Without causing a re-render of hooks that depend on the latest value (Such as effects)
var useRenderRef = function useRenderRef(value) {
  var ref = React.useRef(value);
  ref.current = value;
  return ref;
};
export var useNoScrollEffect = function useNoScrollEffect() {
  var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    classesProp = _ref5.classes,
    _ref5$enabled = _ref5.enabled,
    enabled = _ref5$enabled === void 0 ? true : _ref5$enabled;
  var classes = useClasses(styles, classesProp);
  var noScrollClassRef = useRenderRef(classes['no-scroll']);
  var enabledRef = useRenderRef(enabled);
  React.useEffect(function () {
    if (!enabled) {
      globalAlias[$noScrollMountCount] += 1;
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  React.useEffect(function () {
    var noScrollClass = noScrollClassRef.current;
    var handleClasses = function handleClasses() {
      if (globalAlias[$noScrollMountCount] > 0) {
        var _document$body$classL;
        (_document$body$classL = document.body.classList).add.apply(_document$body$classL, _toConsumableArray(toClassList(noScrollClass)));
      } else if (globalAlias[$noScrollMountCount] === 0) {
        var _document$body$classL2;
        (_document$body$classL2 = document.body.classList).remove.apply(_document$body$classL2, _toConsumableArray(toClassList(noScrollClass)));
      } else {
        throw new Error('No scroll counter should never be less than 0');
      }
    };
    if (enabled) {
      globalAlias[$noScrollMountCount] += 1;
    } else {
      globalAlias[$noScrollMountCount] -= 1;
    }
    handleClasses();
    return function () {
      // Latest ref value is needed in cleanup
      // eslint-disable-next-line react-hooks/exhaustive-deps
      var latestEnabledValue = enabledRef.current;
      if (enabled && latestEnabledValue) {
        // If unmounting without becoming disabled
        globalAlias[$noScrollMountCount] -= 1;
      }
      handleClasses();
    };
  }, [enabled, enabledRef, noScrollClassRef]);
};
export var useGlobalKeyboardEscapeEffect = function useGlobalKeyboardEscapeEffect(_ref) {
  var _ref$enabled = _ref.enabled,
    enabled = _ref$enabled === void 0 ? true : _ref$enabled,
    onEscapeKey = _ref.onEscapeKey;
  React.useEffect(function () {
    var handleKeyDown = function handleKeyDown(event) {
      if (event.key !== 'Escape') return;
      onEscapeKey(event);
    };
    var setup = function setup() {
      document.addEventListener('keydown', handleKeyDown);
    };
    var teardown = function teardown() {
      document.removeEventListener('keydown', handleKeyDown);
    };
    if (enabled) {
      setup();
    } else {
      teardown();
    }
    return teardown;
  }, [enabled, onEscapeKey]);
};
export var useOutsideClickEffect = function useOutsideClickEffect(_ref2, targetRefOrRefs) {
  var _ref2$enabled = _ref2.enabled,
    enabled = _ref2$enabled === void 0 ? true : _ref2$enabled,
    onClickOutside = _ref2.onClickOutside;
  React.useEffect(function () {
    var validRefsFilter = function validRefsFilter(targetRef) {
      return !!(targetRef !== null && targetRef !== void 0 && targetRef.current);
    };
    var handleClick = function handleClick(event) {
      var _context;
      var normalizedRefs = _Array$isArray(targetRefOrRefs) ? targetRefOrRefs : [targetRefOrRefs];
      if (_someInstanceProperty(_context = _filterInstanceProperty(normalizedRefs).call(normalizedRefs, validRefsFilter)).call(_context, function (targetRef) {
        return targetRef.current.contains(event.target);
      })) {
        return;
      }
      onClickOutside(event);
    };
    var setup = function setup() {
      document.addEventListener('click', handleClick, {
        capture: true
      });
    };
    var teardown = function teardown() {
      document.removeEventListener('click', handleClick, {
        capture: true
      });
    };
    if (enabled) {
      setup();
    } else {
      teardown();
    }
    return teardown;
  }, [enabled, onClickOutside, targetRefOrRefs]);
};
export var useDialogEffects = function useDialogEffects(_ref3, dialogRef) {
  var _ref3$onClose = _ref3.onClose,
    onClose = _ref3$onClose === void 0 ? noop : _ref3$onClose,
    _ref3$onClickOutside = _ref3.onClickOutside,
    onClickOutside = _ref3$onClickOutside === void 0 ? noop : _ref3$onClickOutside,
    _ref3$onEscapeKey = _ref3.onEscapeKey,
    onEscapeKey = _ref3$onEscapeKey === void 0 ? noop : _ref3$onEscapeKey,
    _ref3$enabled = _ref3.enabled,
    enabled = _ref3$enabled === void 0 ? true : _ref3$enabled;
  useGlobalKeyboardEscapeEffect({
    enabled: enabled,
    onEscapeKey: React.useCallback(function (event) {
      onEscapeKey(event);
      onClose(event);
    }, [onClose, onEscapeKey])
  });
  useOutsideClickEffect({
    enabled: enabled,
    onClickOutside: React.useCallback(function (event) {
      onClickOutside(event);
      onClose(event);
    }, [onClose, onClickOutside])
  }, dialogRef);
};
var useModalEffects = function useModalEffects(_ref4, dialogRef) {
  var _ref4$onClose = _ref4.onClose,
    onClose = _ref4$onClose === void 0 ? noop : _ref4$onClose,
    _ref4$onClickOutside = _ref4.onClickOutside,
    onClickOutside = _ref4$onClickOutside === void 0 ? noop : _ref4$onClickOutside,
    _ref4$onEscapeKey = _ref4.onEscapeKey,
    onEscapeKey = _ref4$onEscapeKey === void 0 ? noop : _ref4$onEscapeKey,
    classes = _ref4.classes,
    _ref4$enabled = _ref4.enabled,
    enabled = _ref4$enabled === void 0 ? true : _ref4$enabled;
  useNoScrollEffect({
    enabled: enabled,
    classes: classes
  });
  useDialogEffects({
    onClickOutside: onClickOutside,
    onClose: onClose,
    onEscapeKey: onEscapeKey,
    enabled: enabled
  }, dialogRef);
};
export default useModalEffects;